(() => {
  "use strict";

  const SELECTOR_COLLECTION_SIDEBAR = "[data-collection-sidebar]";
  const SELECTOR_COLLECTION_SIDEBAR_SLIDE_OUT = "[data-collection-sidebar-slide-out]";
  const SELECTOR_COLLECTION_SIDEBAR_CLOSE = "[data-collection-sidebar-close]";
  const SELECTOR_ARIA_TOGGLE = "[data-aria-toggle]";
  const CLASS_DRAWER_ANIMATED = "drawer--animated";
  const CLASS_EXPANDED = "expanded";
  const CLASS_NO_MOBILE_ANIMATION = "no-mobile-animation";
  const CLASS_IS_FOCUSED = "is-focused";

  if (!customElements.get("collection-component")) {
    customElements.define("collection-component", class extends HTMLElement {
      constructor() {
        super();
        this.collectionSidebar = this.querySelector(SELECTOR_COLLECTION_SIDEBAR);
        this.groupTagsButton = this.querySelector(SELECTOR_ARIA_TOGGLE);
        this.a11y = window.theme.a11y;
        
        this.groupTagsButtonClickEvent = (event) => this.groupTagsButtonClick(event);
        this.sidebarResizeEvent = () => this.toggleSidebarSlider();
        this.collectionSidebarCloseEvent = (event) => this.collectionSidebarClose(event);
      }

      connectedCallback() {
        if (this.groupTagsButton !== null) {
          document.addEventListener("theme:resize:width", this.sidebarResizeEvent);
          this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent);
          
          if (this.collectionSidebar) {
            setTimeout(() => {
              this.collectionSidebar.classList.remove(CLASS_NO_MOBILE_ANIMATION);
            }, 1000);
          }

          // Observer for aria-expanded changes
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === "attributes") {
                if (mutation.target.getAttribute("aria-expanded") == "true") {
                  this.showSidebarCallback();
                }
              }
            }
          });
          
          observer.observe(this.groupTagsButton, {
            attributes: true,
            childList: false,
            subtree: false
          });
        }

        this.addEventListener("keyup", (event) => {
          if (event.code === "Escape") {
            this.hideSidebar();
          }
        });

        if (this.collectionSidebar) {
          this.collectionSidebar.addEventListener("transitionend", () => {
            if (!this.collectionSidebar.classList.contains(CLASS_EXPANDED)) {
              this.collectionSidebar.classList.remove(CLASS_DRAWER_ANIMATED);
            }
          });

          this.toggleSidebarSlider();
          this.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
        }
      }

      showSidebarCallback() {
        const sidebarSlideOut = this.querySelector(SELECTOR_COLLECTION_SIDEBAR_SLIDE_OUT);
        const isScrollLocked = document.documentElement.hasAttribute("data-scroll-locked");
        const isMobile = window.theme.isMobile();

        this.collectionSidebar.classList.add(CLASS_DRAWER_ANIMATED);

        if (sidebarSlideOut === null && !isMobile && isScrollLocked) {
          this.a11y.removeTrapFocus();
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        }

        if (isMobile || sidebarSlideOut !== null) {
          if (sidebarSlideOut) {
            this.a11y.trapFocus(this.collectionSidebar, {
              elementToFocus: this.collectionSidebar.querySelector(SELECTOR_COLLECTION_SIDEBAR_CLOSE)
            });
          }
          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
        }
      }

      hideSidebar() {
        const sidebarSlideOut = this.querySelector(SELECTOR_COLLECTION_SIDEBAR_SLIDE_OUT);
        const isScrollLocked = document.documentElement.hasAttribute("data-scroll-locked");

        this.groupTagsButton.setAttribute("aria-expanded", "false");
        this.collectionSidebar.classList.remove(CLASS_EXPANDED);

        if (sidebarSlideOut) {
          this.a11y.removeTrapFocus();
        }

        if (isScrollLocked) {
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        }
      }

      toggleSidebarSlider() {
        if (window.theme.isMobile()) {
          this.hideSidebar();
        } else if (this.collectionSidebar.classList.contains(CLASS_EXPANDED)) {
          this.showSidebarCallback();
        }
      }

      collectionSidebarClose(event) {
        event.preventDefault();
        this.hideSidebar();
        
        if (document.body.classList.contains(CLASS_IS_FOCUSED) && this.groupTagsButton) {
          this.groupTagsButton.focus();
        }
      }

      groupTagsButtonClick() {
        if (document.documentElement.hasAttribute("data-scroll-locked")) {
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        }
      }

      disconnectedCallback() {
        if (this.groupTagsButton !== null) {
          document.removeEventListener("theme:resize:width", this.sidebarResizeEvent);
          this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent);
        }

        if (this.collectionSidebar) {
          this.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
        }
      }
    });
  }
})();
